/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PhiatFeeDistribution, PhiatFeeDistributionInterface } from '../PhiatFeeDistribution';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'stakingToken_',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'treasury_',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Recovered',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'rewardToken',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256',
      },
    ],
    name: 'RewardPaid',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Staked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousTreasury',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newTreasury',
        type: 'address',
      },
    ],
    name: 'TreasuryTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'UnstakeCancelled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Unstaked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'receivedAmount',
        type: 'uint256',
      },
    ],
    name: 'Withdrawn',
    type: 'event',
  },
  {
    inputs: [],
    name: 'REWARD_DURATION',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'REWARD_RATE_PRECISION_ASSIST',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UNSTAKE_DURATION',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'WITHDRAW_DURATION',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
    ],
    name: 'addReward',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cancelUnstake',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'claimableRewards',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
        ],
        internalType: 'struct IPhiatFeeDistribution.RewardAmount[]',
        name: 'rewards',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getReward',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
    ],
    name: 'getRewardForDuration',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
    ],
    name: 'lastTimeRewardApplicable',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
    ],
    name: 'recoverERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
    ],
    name: 'rewardPerToken',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'stake',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'stakedBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingToken',
    outputs: [
      {
        internalType: 'contract IERC20Capped',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingTokenPrecision',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'tokenRewards',
    outputs: [
      {
        internalType: 'uint256',
        name: 'periodFinish',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'rewardRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'lastUpdateTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'rewardStored',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'tokens',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalStakedSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newTreasury',
        type: 'address',
      },
    ],
    name: 'transferTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'treasury',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'unstake',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'unstakedBalance',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'time',
            type: 'uint256',
          },
        ],
        internalType: 'struct IPhiatFeeDistribution.TimedBalance',
        name: 'balance',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'withdrawableBalance',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'time',
            type: 'uint256',
          },
        ],
        internalType: 'struct IPhiatFeeDistribution.TimedBalance',
        name: 'balance',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

const _bytecode =
  '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';

export class PhiatFeeDistribution__factory extends ContractFactory {
  constructor(...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    stakingToken_: string,
    treasury_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PhiatFeeDistribution> {
    return super.deploy(stakingToken_, treasury_, overrides || {}) as Promise<PhiatFeeDistribution>;
  }
  getDeployTransaction(
    stakingToken_: string,
    treasury_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(stakingToken_, treasury_, overrides || {});
  }
  attach(address: string): PhiatFeeDistribution {
    return super.attach(address) as PhiatFeeDistribution;
  }
  connect(signer: Signer): PhiatFeeDistribution__factory {
    return super.connect(signer) as PhiatFeeDistribution__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PhiatFeeDistributionInterface {
    return new utils.Interface(_abi) as PhiatFeeDistributionInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): PhiatFeeDistribution {
    return new Contract(address, _abi, signerOrProvider) as PhiatFeeDistribution;
  }
}
